import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";

/**
 * AchievementCard — celebra uma conquista do user (todos hábitos do dia,
 * projeto 100%, meta atingida). Verde semitransparente + glow subtle.
 *
 * Props:
 *   title    — texto principal (ex: "Sequência de hábitos completa")
 *   subtitle?— linha secundária (ex: "5/5 — segunda-feira")
 *   progress?— número 0-100, default 100
 */
export default function AchievementCard({ title, subtitle, progress = 100 }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98, boxShadow: "0 0 0 rgba(0, 255, 163, 0)" }}
      animate={{
        opacity: 1,
        scale: 1,
        boxShadow: [
          "0 0 0 rgba(0, 255, 163, 0)",
          "0 0 24px rgba(0, 255, 163, 0.25)",
          "0 0 12px rgba(0, 255, 163, 0.12)",
        ],
      }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-semantic-success/10 border border-semantic-success/20"
      data-testid="ds-achievement-card"
    >
      <div className="w-9 h-9 rounded-full bg-semantic-success/20 flex items-center justify-center shrink-0">
        <CheckCheck className="w-4 h-4 text-semantic-success" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-semantic-success leading-tight">{title}</p>
        {subtitle ? <p className="text-[11px] text-emerald-300/70 mt-0.5">{subtitle}</p> : null}
      </div>
      {progress < 100 ? (
        <span className="text-[11px] tabular-nums text-semantic-success/80 font-medium">
          {progress}%
        </span>
      ) : null}
    </motion.div>
  );
}
